/** Ortak dairesel aksiyon butonu (YouTube, nota, favori). */
export const turkuIconActionButtonClass =
  "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/90 transition hover:border-accent-primary/45 hover:bg-white/10 hover:text-accent-primary disabled:cursor-default disabled:opacity-70";

export const turkuIconActionButtonActiveClass =
  "border-accent-primary/45 text-accent-primary hover:text-accent-primary";
